/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {
    DocumentEyeIcon,
    EmailSubsectionChip, IconScheduleTable, MobileIcon,
    PersonOutlinedChip, TimePickerChip
} from "../../../../../../../components/buttons/IconButtons";
import CustomGenericTittleIconDataChip from "../../../../../../../components/CustomGenericTittleIconDataChip";
import CustomChip from "../../../../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../../../enums/statusColorEnum";
import {status} from "../../../../../../../enums/statusEnum";
import {useTranslation} from "react-i18next";
import {
    calculateHeight,
    downloadActionFile,
    EMPTY_VALUES,
    getDateFormat,
    getTimeFormat,
    isSmWidth
} from "../../../../../../../Apis/functions";
import CustomTooltip from "../../../../../../../components/CustomTooltip";
import NotInformation from "../../../../../../../components/NotInformation";
import CustomFileCard from "../../../../../../../components/CustomFileCard";
import React, {useLayoutEffect, useRef} from "react";
import {CustomLevelCardStyle} from "../../../../../../../components/Styles";

const RequestedDetailsSection = ({
    item,
    evidence,
    contentCardRef,
    statusId
}) => {

    const {t} = useTranslation();
    const styles = CustomLevelCardStyle(statusId, false);
    const elementRef = useRef();

    useLayoutEffect(() => {
        if(isSmWidth()) return;
        calculateHeight({elementRef: elementRef, bottom:100})
    }, [item]);

    return (
        <>
            <div style={styles.container}>
                <div className='d-flex justify-content-between align-items-center' style={styles.levelCard}>
                    <CustomGenericTittleIconDataChip
                        title={'details'}
                        Icon={DocumentEyeIcon}
                        border={false}
                        titleBoxClass={'d-flex'}
                    />
                    <CustomChip
                        variant={'large'}
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={t(status[statusId])}
                    />
                </div>

                <div className='row align-items-start p-3 overflow-y-auto' ref={contentCardRef}>
                    <div className='col-2 p-0'>
                        <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center'>
                            <PersonOutlinedChip/>
                        </div>
                    </div>
                    <div className='col-10'>
                        <div className='row px-0 ml-0 pl-0'>
                            <div className='col-12 px-0'>
                                <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 '>
                                    {t('supervisor')}
                                </p>
                                <p className='font-color-general-950 fs-14px ibl-font-w-400 px-0 mb-1'>
                                    {item?.requestedBy || EMPTY_VALUES.DEFAULT}
                                </p>
                            </div>
                            <div className={'row mt-2 ml-0 pl-0 ml-0'}>
                                <div className={'d-flex justify-content-between p-0 gap-3 '}>
                                    <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                                        <div className={'mr-2 d-flex align-items-center'}>
                                            <EmailSubsectionChip/>
                                        </div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={item?.email || EMPTY_VALUES.DEFAULT}
                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row align-items-center`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                    <div className={'d-flex flex-grow-1 minw-0'}>
                                        <div className={'mr-2 d-flex align-items-center'}>
                                            <MobileIcon className='icon-color-shades-800 flex-shrink-0'/>
                                        </div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={item?.phoneNumber || EMPTY_VALUES.DEFAULT}
                                                classes={`fs-14px font-color-general-950 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='border-bottom-shades-300 my-3'/>

                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>{t('request_date')}</p>
                            <div className='col-sm-12 col-md-6 px-0'>
                                <div className='d-flex align-items-center'>
                                    <IconScheduleTable/>
                                    <p className='font-color-general-950 fs-14px ml-2'>
                                        {item?.requestDate ? getDateFormat(item?.requestDate, false) : EMPTY_VALUES.DEFAULT}
                                    </p>
                                </div>
                            </div>
                            <div className='col-sm-12 col-md-6 px-0'>
                                <div className='d-flex align-items-center'>
                                    <TimePickerChip/>
                                    <p className='font-color-general-950 fs-14px ml-2'> {item?.requestDate ? getTimeFormat(item?.requestDate) : EMPTY_VALUES.DEFAULT}</p>
                                </div>
                            </div>

                            <div className='border-bottom-shades-300 my-3'/>

                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>
                                {t('comment')}
                            </p>
                            <p className='font-color-general-950 fs-14px px-0'>
                                {item?.description || EMPTY_VALUES.DEFAULT}
                            </p>
                            <div className='border-bottom-shades-300 mt-3'/>
                            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 my-3'>
                                {t('attachments')}
                            </p>

                            {evidence?.length === 0 ?
                                <div className='px-0' ref={elementRef}>
                                    <NotInformation text={t('no_evidence_registered')} card={true} className={"h-100"}
                                                    classNameImage={"h-100px py-1"}/>
                                </div>
                                :
                                <div className='overflow-y-auto px-0' ref={elementRef}>
                                    {evidence?.map((e) => {
                                        return (
                                            <div className={'mt-2'}>
                                                <CustomFileCard
                                                    Icon={e.Icon}
                                                    title={e.name}
                                                    subtitle={
                                                        <p className={'justify-content-start d-flex ibl-font-w-400 fs-10px'}>
                                                            {e.size}
                                                        </p>
                                                    }
                                                    fileValue={e.filePath}
                                                    buttonId={'btn_rds_download_' + e.id}
                                                    onClick={() => downloadActionFile(e.filePath)}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RequestedDetailsSection;
